import axios from './api'
import { params2QueryString, queryString } from './utils'
import { DOMAIN } from './config'
import router from '../../router'
/**
 * 统一异常处理
 * 异常代码:
 * 999 需要登录
 * 500 '服务器回家吃饭啦, 请稍后再试!'
 */
// axios.defaults.withCredentials = true
function fixedUrl (url) {
  if (/^https?/.test(url)) {
    return url
  } else {
    return `${DOMAIN}${/^\//.test(url) ? '' : '/'}${url}`
  }
}
const ajax = {
  upload (url, params) {
    return axios.post(fixedUrl(url), params)
      .catch(err => {
        console.error(err)
        return Promise.reject(err)
      })
      .then(res => {
        const {data: {flag, data, errorMsg}} = res
        if (flag === 1) {
          return data
        }
        if (flag === 999) {
          router.push('/passport')
          // return Promise.reject('未登录')
        }
        return Promise.reject(errorMsg)
      })
  }
}
function request (method, url, params) {
  if (method === 'get') {
    return axios[method](params2QueryString(fixedUrl(url), params))
  } else {
    return axios({
      method,
      url: fixedUrl(url),
      data: queryString(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    })
  }
}
['get', 'post'].forEach(method => {
  ajax[method] = (url, params) => {
    return request(method, url, params)
      .catch(err => {
        console.error(err)
        return Promise.reject(err)
      })
      .then(res => {
        const {data: {flag, data, errorMsg}} = res
        if (flag === 1) {
          return data
        }
        if (flag === 999) {
          router.push('/passport')
        }
        return Promise.reject(errorMsg)
      })
  }
})
export default ajax



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js